import React, { useEffect, useState } from 'react'
import BasicButton from '../ui/BasicButton'
import { useAppSelector } from '../../redux/hooks'
import { getBusinessInfor } from '../../api/common'

interface Props {
  hostId: string
  propertyId?: string
  updateView: (_v: string) => void
}

const BookingSuccessed: React.FC<Props> = ({ hostId }) => {
  const { guestInfo, listingData } = useAppSelector((state) => state.property)
  const [businessInfor, setBusinessInfor] = useState<any>(null)

  console.log('--hostId--', hostId)
  useEffect(() => {
    async function fetchBusinessInfo(hostId: string) {
      const res = await getBusinessInfor(hostId)
      setBusinessInfor(res)
    }
    if (hostId) {
      fetchBusinessInfo(hostId)
    }
  }, [hostId])

  console.log('--businessInfor--', businessInfor)
  const hostPhone = listingData?.contact?.contactPhone1 || listingData?.contact?.contactPhone2 || businessInfor?.phone
  const hostEmail = listingData?.contact?.contactEmail || businessInfor?.email

  return (
    <div>
      <div
        className={'dtravel-flex-col dtravel-center-block dtravel-dtravel-gap-16 dtravel-booking-successed-container'}
      >
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M44.9359 16.8631C45.6193 17.5465 45.6193 18.6545 44.9359 19.3379L25.1369 39.1369C24.4535 39.8203 23.3455 39.8203 22.6621 39.1369L12.7626 29.2374C12.0791 28.554 12.0791 27.446 12.7626 26.7626C13.446 26.0791 14.554 26.0791 15.2374 26.7626L23.8995 35.4246L42.461 16.8631C43.1445 16.1796 44.2525 16.1796 44.9359 16.8631Z"
              fill="#4B9548"
            />
          </svg>
        </span>
        <p className={'dtravel-inter-400 dtravel-text-20-28 dtravel-neutral-900'}>Your reservation is completed</p>
        <p className={'dtravel-inter-400 dtravel-text-14-20 dtravel-neutral-600'}>
          A confirmation was sent to {guestInfo.email}
        </p>
      </div>

      <div
        className={` dtravel-booking-successed-content ${
          hostEmail || hostPhone ? 'dtravel-flex-col dtravel-center-block dtravel-dtravel-gap-16' : 'hidden'
        }`}
      >
        <p
          className={
            'dtravel-inter-400 dtravel-text-14-20 dtravel-neutral-900 dtravel-text-center dtravel-booking-successed-text'
          }
        >
          Have a question about your reservation? <br /> Get in touch with us:
        </p>

        {hostPhone && (
          <p
            className={
              'dtravel-center-block dtravel-gap-8 dtravel-inter-600 dtravel-text-14-20 dtravel-neutral-900 dtravel-booking-successed-icon'
            }
          >
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M5.09729 2H3.26316C2.56554 2 2 2.56554 2 3.26316C2 9.19295 6.80705 14 12.7368 14C13.4345 14 14 13.4345 14 12.7368V10.9027C14 10.3575 13.6681 9.86723 13.1619 9.66474L11.4047 8.9619C10.95 8.78001 10.4322 8.86205 10.056 9.17557L9.60207 9.55383C9.0723 9.99531 8.2933 9.95997 7.80568 9.47235L6.52765 8.19432C6.04003 7.7067 6.00469 6.9277 6.44617 6.39793L6.82443 5.94402C7.13795 5.56779 7.21999 5.04997 7.0381 4.59525L6.33526 2.83815C6.13277 2.33193 5.6425 2 5.09729 2Z"
                  stroke="#292926"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span>{hostPhone}</span>
          </p>
        )}

        {hostEmail && (
          <p className={'dtravel-center-block dtravel-gap-8 dtravel-inter-600 dtravel-text-14-20 dtravel-neutral-900'}>
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.5 4C1.5 3.35566 2.02233 2.83333 2.66667 2.83333H13.3333C13.9777 2.83333 14.5 3.35566 14.5 3.99999V12C14.5 12.6443 13.9777 13.1667 13.3333 13.1667H2.66667C2.02233 13.1667 1.5 12.6443 1.5 12V4ZM2.66667 3.83333C2.57462 3.83333 2.5 3.90795 2.5 4V12C2.5 12.092 2.57462 12.1667 2.66667 12.1667H13.3333C13.4254 12.1667 13.5 12.092 13.5 12V3.99999C13.5 3.90795 13.4254 3.83333 13.3333 3.83333H2.66667Z"
                  fill="#292926"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.60121 3.69842C1.76777 3.47816 2.08134 3.43463 2.3016 3.60118L8.16268 8.03317L13.6875 3.60969C13.9031 3.4371 14.2177 3.47193 14.3903 3.68749C14.5629 3.90306 14.5281 4.21772 14.3125 4.39031L8.48396 9.05697C8.30533 9.19999 8.05241 9.2035 7.86988 9.06548L1.69845 4.39881C1.4782 4.23226 1.43466 3.91868 1.60121 3.69842Z"
                  fill="#292926"
                />
              </svg>
            </span>
            <span>{hostEmail}</span>
          </p>
        )}
      </div>

      {/*---Footer---*/}
      <div className="dtravel-footer-container">
        <BasicButton
          variant={'contained'}
          color={'black'}
          clases={'dtravel-w-full'}
          size={'lg'}
          onClick={() => {
            if (window.closeDtravelWidget) {
              window.closeDtravelWidget()
            }
          }}
        >
          Close
        </BasicButton>
      </div>
    </div>
  )
}

export default BookingSuccessed
